export const timesUpFr = [
  "(Charles) Abbé de l'Epée",
  "Abbé Pierre",
  "Victoria Abril",
  "Actarus",
  "Isabelle Adjani",
  "André Agassi",
  "Aladdin",
  "Alf",
  "Mohammed Ali",
  "Woody Allen",
  "Pedro Almodovar",
  "Richard Anconina",
  "Claudie André-Deshays",
  "Jean-Jacques Annaud",
  "Jacques Anquetil",
  "San Antonio",
  "Daniel Auteuil",
  "Charles Aznavour",
  "Ali Baba",
  "Jean-Sébastien Bach",
  "Pierre Bachelet",
  "Francis Bacon",
  "Jean-Pierre Bacri",
  "(Robert) Baden-Powell",
  "Robert Badinter",
  "Joséphine Baker",
  "Josiane Balasko",
  "Daniel Balavoine",
  "Rocky Balboa",
  "Edouard Balladur",
  "Honoré de Balzac",
  "Antonio Banderas",
  "Barbara",
  "Barbe-noire",
  "Brigitte Bardot",
  "Le Baron Rouge",
  "Joséphine de Beauharnais",
  "Simone de Beauvoir",
  "(Vautier) Ben",
  "Roberto Benigni",
  "Michel Berger",
  "Cyrano de Bergerac",
  "Ingrid Bergman",
  "Stéphane Bern",
  "Sarah Bernhardt",
  "Chuck Berry",
  "Bernardo Bertolucci",
  "Henry Bescherelle",
  "Luc Besson",
  "Chandler Bing",
  "Juliette Binoche",
  "Jane Birkin",
  "Michel Blanc",
  "Blanche-neige",
  "Louis Blériot",
  "Mike Blueberry",
  "Enid Blyton",
  "David Bowie",
  "Ray (Douglas) Bradbury",
  "Louis Braille",
  "Marlon Brando",
  "Georges Brassens",
  "Claude Brasseur",
  "Eva Braun",
  "Christine Bravo",
  "Pépin le Bref",
  "(Leonid Illitch) Brejnev",
  "Jacques Brel",
  "Claire Brétecher",
  "André Breton",
  "Charlie Brown",
  "(Pieter) Bruegel",
  "Patrick Bruel",
  "Buffalo Bill",
  "Sitting Bull",
  "Bugs Bunny",
  "Mariah Carey",
  "Carlos",
  "Marcel Carné",
  "Lewis carroll",
  "Jacques Cartier",
  "Barbara Cartland",
  "Casimir",
  "Vincent Cassel",
  "Bianca Castafiore",
  "Fidel Castro (Ruz)",
  "Antoine de Caunes",
  "Louis-Ferdinand Céline",
  "Cendrillon",
  "Cervantès",
  "Jules César",
  "(Baldaccini) César",
  "Paul Cézanne",
  "Alain Chabat",
  "Richard Chamberlain",
  "Christian Clavier",
  "John Cleese",
  "Cléopâtre",
  "Julien Clerc",
  "Inspecteur Clouseau",
  "Clovis 1er",
  "Jean Cocteau",
  "Jean-Pierre Coffe",
  "Daniel Cohn-Bendit",
  "(Sidonie) Colette",
  "Phil Collins",
  "Christophe Colomb",
  "Michel Colucci",
  "Columbo",
  "Nadia Comaneci",
  "Le Comte de Monte-Cristo",
  "Conan le barbare",
  "Confucius",
  "Sean Connery",
  "Le Corbusier",
  "Pierre de Coubertin",
  "Edmond Dantès",
  "(Georges Jacques) Danton",
  "Lawrence d'Arabie",
  "Jeanne d'Arc",
  "Frédéric Dard",
  "D'Artagnan",
  "Charles Darwin",
  "Joe Dassin",
  "Jacques Delors",
  "Catherine Deneuve",
  "Gérard Depardieu",
  "René Descartes",
  "Harlem Désir",
  "Pierre Desproge",
  "Patrick Dewaere",
  "Pine d'Huître",
  "Leonardo Di Caprio",
  "Philip Dick",
  "Charles Dickens",
  "Denis Diderot",
  "Marlène Dietrich",
  "Philippe de Dieuleveult",
  "Diogène",
  "Céline Dion",
  "Walter Disney",
  "Robert Doisneau",
  "Dolly",
  "Le douanier Rousseau",
  "Albert Einstein",
  "Dwight Eisenhower",
  "El Greco",
  "Jean-Pierre Elkabbach",
  "Boris Eltsine",
  "Euclide",
  "Chris Evert",
  "Lara Fabian",
  "Juan Manuel Fangio",
  "Fantômas",
  "Farinelli",
  "Mylène Farmer",
  "Dominique Farrugia",
  "Fernandel",
  "Léo Ferré",
  "Jules Ferry",
  "Bobby Fisher",
  "Ella Fitzgerald",
  "Louis de Funès",
  "Serge Gainsbourg",
  "Michel Galabru",
  "Galahad",
  "Galilée",
  "France Gall",
  "Vasco de Gama",
  "Greta Garbo",
  "Sergent Garcia",
  "Richard Garfield",
  "Gargantua",
  "Maurice Garin",
  "Judy Garland",
  "Simone Garnier",
  "Laurent Garnier",
  "Roland Garros",
  "Bill Gates",
  "Antonio Gaudi",
  "Paul Gauguin",
  "Charles de Gaulle",
  "Le Géant Vert",
  "Steffi Graf",
  "Hermione Granger",
  "Cary Grant",
  "Maurice Grevisse",
  "Matt Groening",
  "(Ernesto) Che Guevara",
  "(Joseph Ignace) Guillotin",
  "(Lemuel) Gulliver",
  "Forrest Gump",
  "Johannes Gutenberg",
  "Gary Gygax",
  "Louis Hachette",
  "Gene Hackman",
  "Capitaine Haddock",
  "Johnny Hallyday",
  "Mark Hamill",
  "Hamlet",
  "Georg Friedrich Händel",
  "Sherlock Holmes",
  "Gérard Holtz",
  "Homère",
  "John Edgar Hoover",
  "Anthony Hopkins",
  "Victor Horta",
  "Harry Houdini",
  "Whitney Houston",
  "Huggy les bons tuyaux",
  "Victor Hugo",
  "Jacky Ickx",
  "Imhotep",
  "John Irving",
  "Jack l'éventreur",
  "Michael Jackson",
  "Peter Jackson",
  "Jacquouille la fripouille",
  "Mick Jagger",
  "(Iscariote) Judas",
  "Gérard Jugnot",
  "Patricia Kaas",
  "Franz Kafka",
  "Emmanuel Kant",
  "Mathieu Kassovitz",
  "Buster Keaton",
  "Harvey Keitel",
  "Ellen Keller",
  "Grace Kelly",
  "Clark Kent",
  "Khaled",
  "Gengis Khan",
  "Nikita (Sergueëvitsh) Kroutchev",
  "Stephen King",
  "Martin Luther King",
  "Rudyard Kipling",
  "(James Tiberius) Kirk",
  "Christophe Lambert",
  "(Henri Désiré) Landru",
  "Lois Lane",
  "Jack Lang",
  "Fritz Lang",
  "Pierre Larousse",
  "Lassie",
  "Stan Laurel",
  "Dominique Lavanant",
  "Bernard Lavilliers",
  "(Antoine Laurent) Lavoisier",
  "Saint Lazare",
  "Gaston Leroux",
  "Nolwenn Leroy",
  "Julie Lescaut",
  "Pierre Lescure",
  "Claude Levi-Strauss",
  "Bernard-Henry Lévy",
  "Monica Lewinsky",
  "Carl Lewis",
  "Jerry Lewis",
  "Jerry Lee Lewis",
  "Thierry Lhermitte",
  "Jet Li",
  "Abraham Lincoln",
  "Charles Lindbergh",
  "Lio",
  "Loana",
  "Gina Lollobrigida",
  "Jack London",
  "(Fernand de) Magellan",
  "Maïté",
  "Gérard Majax",
  "Nelson Mandela",
  "Jean Marais",
  "(Jean Paul) Marat",
  "Sophie Marceau",
  "Ferdinand Marcos",
  "Marianne",
  "Luis Mariano",
  "Marie-Antoinette",
  "Bob Marley",
  "Charles Martel",
  "Jacques Martin",
  "Groucho (Julius) Marx",
  "Karl Marx",
  "Jeanne Mas",
  "Bruno Masure",
  "Mata Hari",
  "Claude Monet",
  "Miss Moneypenny",
  "Marilyn Monroe",
  "Monsieur Jourdain",
  "Monsieur Preskovic",
  "Gilbert Montagné",
  "Roméo Montaigus",
  "Yves Montand",
  "Carolle Montillet",
  "Jeanne Moreau",
  "Jim Morrison",
  "Samuel Morse",
  "Jean Moulin",
  "Mowgli",
  "Wolfgang Amadeus Mozart",
  "Fox Mulder",
  "(Edvard) Munch",
  "Eddie Murphy",
  "Sinead O'Connor",
  "Scarlett O'Hara",
  "Yoko Ono",
  "George Orwell",
  "Lee Harvey Oswald",
  "Peter O'Toole",
  "Gérard Oury",
  "Ovide",
  "Jesse Owens",
  "Al Pacino",
  "Marcel Pagnol",
  "Florent Pagny",
  "Peter Pan",
  "Panpan",
  "Vanessa Paradis",
  "Pâris",
  "Blaise Pascal",
  "Louis Pasteur",
  "Pinocchio",
  "Brad Pitt",
  "Bernard Pivot",
  "Platon",
  "Pocahontas",
  "Edgar Allan Poe",
  "Hercule Poirot",
  "Patrick Poivre d'Arvor",
  "Roman Polanski",
  "Jackson Pollock",
  "Pollux",
  "Michel Polnareff",
  "Marco Polo",
  "Popeye",
  "Mary Poppins",
  "Porthos",
  "Poséidon",
  "Eugène (René) Poubelle",
  "Raspoutine",
  "Robert Redford",
  "Christopher Reeves",
  "(Harmenszoon van Rijn) Rembrandt",
  "(Séchan) Renaud",
  "Pierre Auguste Renoir",
  "Alain Resnais",
  "Paul Ricard",
  "Anne Rice",
  "Pierre Richard",
  "Richard coeur de lion",
  "Arthur Rimbaud",
  "Catherine Ringer",
  "Rintintin",
  "Helen Ripley",
  "Dick Rivers",
  "Paul Robert",
  "Julia Roberts",
  "Tom Sawyer",
  "(Egon) Schiele",
  "(Oskar) Schindler",
  "Robert Schuman",
  "Arnold Schwarzenegger",
  "Albert Schweitzer",
  "Ridley Scott",
  "Scoubidou",
  "Tom Selleck",
  "Elie Semoun",
  "Ayrton Senna",
  "Michel Serrault",
  "William Shakespeare",
  "Shéhérazade",
  "Sheila",
  "Mary Shelley",
  "Simone Signoret",
  "Georges Simenon",
  "Joseph Staline",
  "Henry Stanley",
  "Philippe Starck",
  "Ringo Starr",
  "Joey Starr",
  "Henri Stendhal",
  "Sting",
  "Bram Stoker",
  "Igor Stravinsky",
  "Meryl Streep",
  "Monsieur Sylvestre",
  "Eric Tabarly",
  "Quentin Tarantino",
  "Tarzan",
  "Jacques Tati",
  "Elisabeth Taylor",
  "(Piotr Ilitch) Tchaïkovski",
  "Anton (Pavlovitch) Tchekhov",
  "Albert Uderzo",
  "Ulysse",
  "Dark Vador",
  "Jean Valjean",
  "Ludwig van Beethoven",
  "Vincent Van Gogh",
  "Jean Van Hamme",
  "Lino Ventura",
  "Vercingétorix",
  "(Giuseppe) Verdi",
  "Paul Verlaine",
  "Jules Verne",
  "André Vésale",
  "Boris Vian",
  "Paul Emile Victor",
  "Jacques Villeret",
  "David Vincent",
  "(Antonio) Vivaldi",
  "Emil Zatopek",
  "Karl Zéro",
  "Zeus",
  "Zinedide Zidane",
  "Emile Zola",
  "Jacques Chirac",
  "Francois Mitterand",
  "Charles de Gaule",
  "Nicolas Sarkozy",
  "Anne Roumanoff",
  "Laurent Ruquier",
  "Philippe Séguin",
  "Francis Perrin",
  "Milla Jovovich",
  "Laure Manaudou",
  "Victoria Beckham",
  "Dominique Strauss-Kahn",
  "Danièle Evenou",
  "Michel Drucker",
  "Oussama Ben Laden",
  "Björk",
  "Kurt Cobain",
  "Bernard Tapie",
  "Jean-Paul II",
  "Dustin Hoffman",
  "Steven Spielberg",
  "Alain Delon",
  "Charlemagne",
  "Toutânkhamon",
  "Brigitte Lahaie",
  "Mahatma Gandhi",
  "Napoléon Bonaparte",
  "Thomas Edison",
  "Benjamin Franklin",
  "George Washington",
  "Jules-Édouard Moustic",
  "Madonna",
  "Hu Jintao",
  "Steve Ballmer",
  "Frankenstein",
  "Philippe Gildas",
  "Jérôme Bonaldi",
  "Michel Sardou",
  "Usain Bolt",
  "Byran Adams",
  "Alain Afflelou",
  "Akira",
  "Albator",
  "Jean Alési",
  "Dodi Al-Fayed",
  "(Aloïs) Alzheimer",
  "Idi Admin Dada",
  "Pamela Anderson",
  "Anémone",
  "Angélique Marquise des Anges",
  "Jennifer Aniston",
  "Jean Anouilh",
  "Louis Aragon",
  "Pierre Arditi",
  "Lance Armstrong",
  "Rosanna Arquette",
  "Jacques Attali",
  "Attila",
  "Hugues Auffray",
  "Marc Aurèle",
  "Tex Avery",
  "Marcel Aymé",
  "Lauren Bacall",
  "Laurent Baffie",
  "Barbe Bleue",
  "Didier Barbelivien",
  "Barbie",
  "Eddie Barclay",
  "Fabien Barthez",
  "Alain Bashung",
  "Kim Basinger",
  "Georges Bataille",
  "Jack Bauer",
  "Mister Bean",
  "Bécassine",
  "Samuel Beckett",
  "David Beckham",
  "Belle des Champs",
  "Luciano Benetton",
  "Oncle Ben's",
  "Silvio Berlusconi",
  "Léonard Bernstein",
  "Ingrid Betancourt",
  "Robert Bidochon",
  "Billy The Kid",
  "Georges Bizet",
  "Tony Blair",
  "Francis Blanche",
  "Bob l'éponge",
  "Igor Bogdanoff",
  "Richard Bohringer",
  "Sandrine Bonnaire",
  "Dany Boon",
  "Henri Bosco",
  "Hugo Boss",
  "Bouddha",
  "Michel Boujenah",
  "Didier Bourdon",
  "Boutros Boutros-Ghali",
  "Philippe Bouvard",
  "Mike Brant",
  "Justin Bridou",
  "Dany Brillant",
  "Benoit Brisefer",
  "Sydney Bristow",
  "Charles Bronson",
  "Mario Bros",
  "Dan Brown",
  "Carla Bruni",
  "Brutus",
  "Sandra Bullock",
  "Nestor Burma",
  "Tim Burton",
  "Buzz l'éclair",
  "Nicolas Cage",
  "Caïn",
  "Jeanne Calment",
  "Naomi Campbell",
  "Eric Cantona",
  "Capitaine Flam",
  "Capitaine Némo",
  "Truman Capote",
  "Carmen",
  "Jim Carrey",
  "(Louis-Dominique) Cartouche",
  "Casper",
  "Butch Cassidy",
  "Laetitia Casta",
  "Catwoman",
  "Jean-Marie Cavada",
  "Jacques Chancel",
  "Mathieu Chédid",
  "Karen Cheryl",
  "Chewbacca",
  "Bernadette Chirac",
  "Pétula Clark",
  "George Clinton",
  "Bill Clinton",
  "Joe Cocker",
  "Léonard Cohen",
  "Colonel Moutarde",
  "David Copperfield",
  "Annie Cordy",
  "Pierre Corneille",
  "Bill Cosby",
  "Kevin Costner",
  "Julien Courbet",
  "Darry Cowl",
  "(Vil) Coyote",
  "Michael Crichton",
  "Russel Crow",
  "Tom Cruise",
  "Cthulhu",
  "Macaulay Cukin",
  "Pierre Dac",
  "Averell Dalton",
  "Joe Dalton",
  "Gérard Darmon",
  "Miles Davis",
  "François-René de Chateaubriand",
  "Pierre de Fermat",
  "Jean de Florette",
  "Olivier de Kersauson",
  "Guy de Maupassant",
  "Stéphanie de Monaco",
  "Brice de Nice",
  "Brian de Palma",
  "Lanfeust de Troy",
  "Philippe de Villiers",
  "Régine Deforges",
  "Bertrand Delanoë",
  "Michel Denisot",
  "Johnny Depp",
  "Odile Deray",
  "Henri Dès",
  "Guy des Cars",
  "Raymond Devos",
  "Cameron Diaz",
  "Moby Dick",
  "Dionysos",
  "Christian Dior",
  "Sacha Distel",
  "Docteur Maboul",
  "Arielle Dombasle",
  "Placido Domingo",
  "Dora l'exploratrice",
  "Marc Dorcel",
  "Jean d'Ormesson",
  "Michael Douglas",
  "David Douillet",
  "Jean Dujardin",
  "Dumbo",
  "Albert Dupontel",
  "André Dussollier",
  "Yves Duteil",
  "Bob Dylan",
  "E.T.",
  "Edward aux mains d'argent",
  "Billy Elliott",
  "Eminem",
  "Soeur Emmanuelle",
  "(Daniel Gabriel) Fahrenheit",
  "Roger Federer",
  "François Feldman",
  "Federico Fellini",
  "Enzo Ferrari",
  "Lolo Ferrari",
  "Thomas Fersen",
  "Fifi Brindacier",
  "Laurent Fignon",
  "Huckleberry Finn",
  "Henri Flammarion",
  "Larry Flynt",
  "Docteur Folamour",
  "Jane Fonda",
  "Henri Ford",
  "Brigitte Fossey",
  "Jodie Foster",
  "Jean-Pierre Foucault",
  "Samantha Fox",
  "Capitaine Fracasse",
  "Anatole France",
  "Saint François d'Assise",
  "Michel Fugain",
  "Bison Futé",
  "Inspecteur Gadget",
  "Gandalf",
  "José Garcia",
  "(José) Garcimore",
  "Gargamel",
  "Léon Gaumont",
  "Marvin Gaye",
  "Anne Geddes",
  "Ross Geller",
  "Mel Gibson",
  "Terry Gilliam",
  "Annie Girardot",
  "Jean-Luc Godart",
  "Gollum",
  "Charles Goodyear",
  "Gorge Prodonde",
  "Chantal Goya",
  "Le Grand Schtroumpf",
  "Gromit",
  "Sacha Guitry",
  "Doc Gynéco",
  "Roger Hanin",
  "David Hasselhoff",
  "Tony Hawk",
  "(Abraham) Van Helsing",
  "Pat Hibulaire",
  "Mary Higgins Clark",
  "Patricia Highsmith",
  "Benny Hill",
  "Paris Hilton",
  "Martina Hingis",
  "Hippocrate",
  "Yvette Horner",
  "Robert Hossein",
  "Hulk",
  "Nicolas Hulot",
  "Isabelle Huppert",
  "Icare",
  "Idéfix",
  "Charles Ingalls",
  "(Jean-Auguste-Dominique) Ingres",
  "Eugène Ionesco",
  "Ivan le Terrible",
  "Ivanhoé",
  "Iznogoud",
  "Rabbi Jacob",
  "Christian Jacq",
  "Albert Jacquard",
  "Armand Jammot",
  "Jean-Michel Jarre",
  "Angelina Jolie",
  "Norah Jones",
  "Bridget Jones",
  "(Carl Gustav) Jung",
  "Patrick Juvet",
  "Elie Kakou",
  "Adriana Karembeu",
  "Nicole Kidman",
  "Kirikou",
  "Cédric Klapisch",
  "Stanley Kubrick",
  "La Belle de Cadix",
  "la Bête du Gévaudan",
  "La Brute",
  "La Cicciolina",
  "Kermit la Grenouille",
  "La Panthère Rose",
  "la Vénus de Milo",
  "Père Lachaise",
  "Jean-Yves Lafesse",
  "patrice Laffont",
  "Vincent Lagaf'",
  "Karl Lagerfeld",
  "Francis Lalanne",
  "Serge Lama",
  "Lancelot du Lac",
  "Gérard Lanvin",
  "Boby Lapointe",
  "Catherine Lara",
  "Le Baron de Munchausen",
  "Le Chevalier Bayard",
  "Le Clézio",
  "Flipper le Dauphin",
  "Elliott le Dragon",
  "Jonathan le Goéland",
  "Le mime Marcel Marceau",
  "le Père Fourras",
  "Le petit Nicolas",
  "Le Soldat Inconnu",
  "Henri Leconte",
  "Hannibal Lecter",
  "Valérie Lemercier",
  "Vincent Lindon",
  "Mona Lisa",
  "David Livingstone",
  "John Locke",
  "Jennifer Lopez",
  "Louis XIV",
  "Lucky Luke",
  "Mademoiselle Jeanne",
  "Corto Maltese",
  "Milo Manara",
  "Manon des Sources",
  "Marilyn Manson",
  "Diego Maradona",
  "Ricky Martin",
  "Martine",
  "Commandant (Ahmed Chah) Massoud",
  "Amélie Mauresmo",
  "Maya l'abeille",
  "(Claude) Mc Solar",
  "Steve McQueen",
  "(Dimitri) Meindeleïev",
  "Eddy Merckx",
  "George Michael",
  "Milou",
  "Bernard Minet",
  "Kylie Minogue",
  "(Honoré de) Mirabeau",
  "Miss France",
  "Mister T",
  "Mistinguett",
  "Eddy Mitchell",
  "Moby",
  "Monsieur Seguin",
  "Guy Montagné",
  "Michael Moore",
  "Bob Morane",
  "Professeur Moriarty",
  "Mickey Mouse",
  "Nagui",
  "Melody Nelson",
  "Yannick Noah",
  "Chuck Norris",
  "Mamie Nova",
  "Obélix",
  "Pascal Obispo",
  "Oncle Sam",
  "OSS 117",
  "Oui-Oui",
  "Pac Man",
  "Laura Palmer",
  "Sancho Panza",
  "Pandore",
  "Panoramix",
  "Denis Papin",
  "Gustave Parking",
  "Charles Pathé",
  "Maroe-José Pérec",
  "Maréchal Pétain",
  "Docteur Petiot",
  "Armand Peugeot",
  "Nicolas Philibert",
  "Gérard Philippe",
  "Oncle Picsou",
  "François Pignon",
  "Ponce Pilate",
  "Augusto Pinochet",
  "Iggy Pop",
  "Harry Potter",
  "Tom Pouce",
  "Amélie Poulain",
  "Professeur Tournesol",
  "Joseph Pulitzer",
  "R2D2",
  "Paco Rabanne",
  "Raël",
  "Bernard Rapp",
  "Maurice Ravel",
  "Ronald Reagan",
  "Lou Reed",
  "Jean-Marc Reiser",
  "Lionel Richie",
  "André Rieu",
  "Robin des Bois",
  "Robocop",
  "Jean Rochefort",
  "Axel Rose",
  "Jean Roucas",
  "Mickey Rourke",
  "Demis Roussos",
  "Ségolène Royal",
  "Françoise Sagan",
  "Yves Saint-Martin",
  "Saint-Nicolas",
  "Satan",
  "Adolphe Sax",
  "Claudia Schiffer",
  "Schtroumpf Grognon",
  "Michael Schumacher",
  "Steven Seagal",
  "Jerry Seinfield",
  "Jean-Jacques Sampé",
  "Eric Serra",
  "Pascal Sevran",
  "Omar Sharif",
  "Ariel Sharon",
  "Shrek",
  "Mort Shuman",
  "Rocco Siffredi",
  "Bart Simpson",
  "O.J. Simpson",
  "Will Smith",
  "Soeur Sourire",
  "Madame Soleil",
  "Jimmy Somerville",
  "Alain Souchon",
  "Spartacus",
  "Spirou",
  "Silvester Stallone",
  "Sharon Stone",
  "Paul-Loup Sulitzer",
  "Patrick Süskind",
  "Achille Talon",
  "Audrey Tautou",
  "Haroun Tazieff",
  "Guillaume Tell",
  "Terminator",
  "Thalès",
  "Thorgal",
  "Yann Tiersen",
  "Titeuf",
  "Toutatis",
  "Joey Tribbiani",
  "Marie Trintigniant",
  "Madame Tussaud",
  "Mike Tyson",
  "Ugolin",
  "Jean-Claude Van Damme",
  "Bree Van de Kamp",
  "Sébastien Vauban",
  "Jacques Vergès",
  "Henri Vernes",
  "(Eugène-François) Vidocq",
  "Richard Virenque",
  "Bernard Werber",
  "Venus Williams",
  "Bruce Willis",
  "Willow",
  "Largo Winch",
  "Winnie l'ourson",
  "Georges Wolinski",
];
